import { defineStore } from 'pinia';
import { ref } from '@nuxtjs/composition-api';

export const useCategoriesStore = defineStore('categoriesStore', () => {
  const categories = ref([])
  const allCategories = ref([])
  const categoryTree = ref([])
  const categoryPageInfo = ref({})
  const categoryHeaders = {}
  const offeredToCustomerType = ref(null)
  const hasSpecialPrices = ref(null)

  return {
    categories,
    allCategories,
    categoryTree,
    categoryPageInfo,
    categoryHeaders,
    offeredToCustomerType,
    hasSpecialPrices
  }
})
